/*
 * variant-auto-available.js  (STYA v2.2 - 27.08.2026)
 * Rangfolge:  Auf Lager (1)  >  Vorbestellbar (2)  >  Ausverkauft (3).
 *
 *  BEIM LADEN: steht die Standardvariante schlechter als moeglich, wird auf die beste
 *    umgeschaltet (ALLE noetigen Optionen in EINEM Zug). Gleichstand bleibt unveraendert.
 *  BEIM KLICKEN einer Option: die aktuelle Kombi wird RESPEKTIERT, solange sie existiert und
 *    verfuegbar ODER vorbestellbar ist. Nur wenn die Kombi NICHT existiert (z.B. Weiss+Sisal Uni)
 *    oder AUSVERKAUFT ist, wird auf die beste verfuegbare Variante der gewaehlten Option gewechselt.
 *    -> So bleibt z.B. Schwarz + Sisal Muster (vorbestellbar) waehlbar, obwohl Weiss auf Lager ist.
 *
 * Datenquelle: <script data-stya-variants data-product-id="..."> je Produkt
 *   (a=available, q=inventory_quantity, t=tracked, o=options[]). Additiv - kein Kern-Eingriff.
 */
(function () {
  'use strict';

  function tierOf(v) {
    if (!v.a) return 3;            // ausverkauft (available=false)
    if (!v.t || v.q > 0) return 1; // auf lager (ungetrackt oder Bestand > 0)
    return 2;                      // vorbestellbar (verfuegbar, getrackt, Bestand <= 0)
  }

  function readVariants(picker) {
    var pid = picker.getAttribute('data-product-id');
    var el = null;
    if (pid) el = document.querySelector('script[data-stya-variants][data-product-id="' + pid + '"]');
    if (!el && picker.parentNode) el = picker.parentNode.querySelector('script[data-stya-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fieldsetsOf(picker) {
    return Array.prototype.slice.call(picker.querySelectorAll('fieldset[data-fieldset-index]'));
  }

  function currentValues(picker) {
    return fieldsetsOf(picker).map(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });
  }

  function matchCount(vo, current) {
    var m = 0;
    for (var k = 0; k < vo.length; k++) { if (current[k] === vo[k]) m++; }
    return m;
  }

  function findExact(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < values.length; k++) { if (variants[i].o[k] !== values[k]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }

  // Beste Variante: niedrigster Rang; bei Gleichstand die mit den meisten uebereinstimmenden
  // aktuellen Optionswerten (= minimale Aenderung). fixedIdx/fixedVal halten eine Option fest.
  function bestVariant(variants, current, fixedIdx, fixedVal) {
    var b = null, bt = 9, bm = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (fixedIdx != null && v.o[fixedIdx] !== fixedVal) continue;
      var t = tierOf(v);
      var m = matchCount(v.o, current);
      if (t < bt || (t === bt && m > bm)) { b = v; bt = t; bm = m; }
    }
    return b;
  }

  // Schaltet ALLE abweichenden Optionen der Zielvariante gemeinsam (synchron, ein Fetch am Ende).
  function applyDiff(picker, target, current) {
    var fs = fieldsetsOf(picker);
    var changed = false;
    picker.dataset.vaaFixing = '1';
    for (var i = 0; i < fs.length && i < target.o.length; i++) {
      if (current[i] === target.o[i]) continue;
      var radios = Array.prototype.slice.call(fs[i].querySelectorAll('input[type="radio"]'));
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value === target.o[i] && !radios[r].checked) {
          radios[r].click();
          changed = true;
          break;
        }
      }
    }
    setTimeout(function () { delete picker.dataset.vaaFixing; }, 120);
    return changed;
  }

  function process(picker, fixedIdx, fixedVal) {
    if (picker.dataset.vaaFixing === '1') return;
    var variants = readVariants(picker);
    if (!variants || !variants.length) return;
    var current = currentValues(picker);
    if (current.indexOf(null) !== -1) return; // Picker noch nicht vollstaendig gerendert

    var currentVariant = findExact(variants, current);
    var target;

    if (fixedIdx == null) {
      // BEIM LADEN: bestes ueber ALLE Varianten; nur umschalten, wenn aktuelles schlechter ist.
      target = bestVariant(variants, current, null, null);
      var curTier = currentVariant ? tierOf(currentVariant) : 3;
      if (!target || tierOf(target) >= curTier) return; // schon Bestrang -> nichts tun
    } else {
      // BEIM KLICKEN: gueltige + verfuegbare/vorbestellbare Kombi respektieren (kein Tier-Override).
      // Nur eingreifen, wenn die Kombi NICHT existiert oder AUSVERKAUFT (Rang 3) ist.
      if (currentVariant && tierOf(currentVariant) <= 2) return;
      target = bestVariant(variants, current, fixedIdx, fixedVal);
      if (!target) return;
      if (currentVariant && tierOf(target) >= tierOf(currentVariant)) return; // keine Verbesserung moeglich
    }
    applyDiff(picker, target, current);
  }

  function initPicker(picker) {
    if (picker.dataset.vaaInit === '1') return;
    picker.dataset.vaaInit = '1';
    picker.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      var idx = parseInt(t.getAttribute('data-fieldset-index'), 10);
      if (isNaN(idx)) { process(picker, null, null); return; }
      var val = t.value;
      setTimeout(function () { process(picker, idx, val); }, 0);
    });
    process(picker, null, null); // Laden
  }

  function boot() {
    document.querySelectorAll('variant-picker').forEach(initPicker);
    var obs = new MutationObserver(function () {
      document.querySelectorAll('variant-picker:not([data-vaa-init="1"])').forEach(initPicker);
    });
    if (document.body) obs.observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
